import React from 'react';
import './WelcomeSection.css';
import garageBg from '../assets/About-garage.png';        
import companyLogo from '../assets/About-logo.png';     
import { Link } from 'react-router-dom';

const WelcomeSection = () => {
  return (
    <section className="welcome-section">
      <div className="welcome-left">
        <div className="garage-wrapper">
          <img src={garageBg} alt="Garage" className="garage-bg" />
        </div>
      </div>

     <div className="welcome-right">
  <img src={companyLogo} alt="Arkiva Logo" className="company-logo" />

  <h2>
    Where Smart Technology Meets Everyday Car Care – Professional Car Detailing Company
  </h2>

  <p>
    Drive-In Car Spa is more than a brand—it’s a shift in how people across India experience <strong>vehicle maintenance.</strong> Built by Arkiya Innovations LLP, we are a professional car detailing company and <Link className='link-text' to="/">premium car detailing service provider</Link> focused on smart automation, speed, and sustainability. We don’t just wash cars; we engineer convenience into your daily routine with precision systems and intelligent processes.
  </p>

  <p>
    As a trusted premium car detailing service provider, our objective has been clear: to re-engineer car wash to be smooth, dependable, and touch-free. Whether it is your regular drive-in, or you have a large fleet of cars that need service, our solutions scale to your needs—delivering high-end results without any friction, both literally and figuratively.
  </p>
</div>
    </section>
  );
};

export default WelcomeSection;
